import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, SectionDivider } from './Icons';
const testimonials = [{
  name: 'Elena R.',
  age: '48 años',
  image: 'https://cdn.magicpatterns.com/uploads/2mmaUB1NFH5BLHhaWUf8WM/Elena_R..png',
  quote: 'Pasé de despertarme 4 veces por noche y no poder abrocharme mis jeans favoritos, a dormir 7 horas seguidas y sentirme ligera de nuevo. Lo mejor es que no paso hambre. Entender mis hormonas fue la pieza del puzzle que me faltaba.',
  result: 'Vientre desinflamado en 21 días.'
}, {
  name: 'Marta G.',
  age: '52 años',
  image: 'https://cdn.magicpatterns.com/uploads/hpPgoZRxEjRbx4FVrjbvH4/Marta_G..png',
  quote: "Como profesional, la neblina mental me aterraba. Pensé que estaba perdiendo mis facultades. Con el protocolo 'Focus Laser' recuperé mi nitidez mental en la primera semana. Es increíble lo que sucede cuando dejas de castigar a tu cuerpo.",
  result: 'Adiós neblina mental y fatiga.'
}, {
  name: 'Silvia R.',
  age: '46 años',
  image: 'https://cdn.magicpatterns.com/uploads/uBNnn4xyqgDPWCLbNMQjT9/Silvia_R..webp',
  quote: "Lo que más me sorprendió no fue bajar de peso, sino que dejé de pelear contra los antojos. Antes, a las 5 de la tarde, mi cuerpo me pedía azúcar como si fuera una droga. Entender cómo gestionar mi insulina con el 'Timing Circadiano' cambió las reglas del juego. Por primera vez en años, yo mando sobre mi comida y no al revés. Me siento en paz.",
  result: 'Adiós ansiedad por el dulce y -4kg de inflamación.'
}, {
  name: 'Raquel M.',
  age: '50 años',
  image: 'https://cdn.magicpatterns.com/uploads/3aZebsnuwa9XHDteSfyPZV/Raquel_M.png',
  quote: "Pensé que el cansancio era 'el precio de la edad' y que debía resignarme a estar agotada a las 6 de la tarde. Con El Código Hormonal +40 descubrí que mi cortisol estaba por las nubes. Siguiendo el protocolo de desinflamación, mi energía volvió a ser la de mis 30. He vuelto a salir a caminar, a jugar con mis hijos y a tener ganas de hacer planes. No es una dieta, es recuperar tu vida.",
  result: 'Energía estable todo el día y mejor humor.'
}, {
  name: 'Carmen S.',
  age: '54 años',
  image: 'https://cdn.magicpatterns.com/uploads/we4pXMcbtPpgpUedYuFSCi/Carmen_S.png',
  quote: "Soy la reina de las dietas; las he probado todas, desde la keto hasta el ayuno extremo, y siempre terminaba más inflamada. Estaba muy escéptica con este sistema, pero el enfoque en 'enviar señales de seguridad al cuerpo' tuvo todo el sentido. Mis jeans ya no me aprietan y mi piel brilla de nuevo. Si crees que para ti 'nada funciona', es que no has probado a trabajar CON tus hormonas.",
  result: 'Reducción de 2 tallas y piel radiante.'
}];
const ChevronLeft = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-203">
    <polyline points="15 18 9 12 15 6" data-id="element-204" />
  </svg>;
const ChevronRight = ({
  className = 'w-5 h-5'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-205">
    <polyline points="9 18 15 12 9 6" data-id="element-206" />
  </svg>;
export function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(0);
  const goTo = (index: number) => {
    setDirection(index > current ? 1 : -1);
    setCurrent(index);
  };
  const prev = () => {
    setDirection(-1);
    setCurrent(c => c === 0 ? testimonials.length - 1 : c - 1);
  };
  const next = () => {
    setDirection(1);
    setCurrent(c => c === testimonials.length - 1 ? 0 : c + 1);
  };
  const t = testimonials[current];
  const variants = {
    enter: (dir: number) => ({
      x: dir > 0 ? 200 : -200,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (dir: number) => ({
      x: dir > 0 ? -200 : 200,
      opacity: 0
    })
  };
  return <section className="py-8 px-4 md:px-8 bg-brand-creamAlt" data-id="element-207">
      <div className="max-w-4xl mx-auto" data-id="element-208">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-209">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal" data-id="element-210">
            Historias Reales. Resultados Reales.
          </h2>
        </motion.div>

        <div className="relative" data-id="element-211">
          {/* Navigation arrows */}
          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 md:-translate-x-6 z-20 w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center text-brand-green hover:bg-brand-cream transition-colors" aria-label="Testimonio anterior" data-id="element-212">
            <ChevronLeft data-id="element-213" />
          </button>
          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 md:translate-x-6 z-20 w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center text-brand-green hover:bg-brand-cream transition-colors" aria-label="Siguiente testimonio" data-id="element-214">
            <ChevronRight data-id="element-215" />
          </button>

          {/* Card */}
          <div className="overflow-hidden mx-6 md:mx-0" data-id="element-216">
            <AnimatePresence mode="wait" custom={direction} data-id="element-217">
              <motion.div key={current} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
              duration: 0.35,
              ease: 'easeInOut'
            }} className="bg-white rounded-2xl shadow-md border-t-4 border-brand-green overflow-hidden" data-id="element-218">
                <div className="flex flex-col md:flex-row" data-id="element-219">
                  {/* Image */}
                  <div className="md:w-64 flex-shrink-0" data-id="element-220">
                    <img src={t.image} alt={t.name} className="w-full h-48 md:h-full object-cover" data-id="element-221" />
                  </div>

                  {/* Content */}
                  <div className="p-6 md:p-8 flex flex-col justify-between flex-1" data-id="element-222">
                    <div data-id="element-223">
                      <div className="flex gap-1 text-brand-gold mb-4" data-id="element-224">
                        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4" data-id="element-225" />)}
                      </div>

                      <p className="text-base md:text-lg text-brand-charcoal/80 italic leading-relaxed" data-id="element-226">
                        "{t.quote}"
                      </p>
                    </div>

                    <div className="mt-6 pt-4 border-t border-brand-creamAlt flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3" data-id="element-227">
                      <div data-id="element-228">
                        <p className="font-bold text-brand-charcoal" data-id="element-229">
                          {t.name}
                        </p>
                        <p className="text-sm text-brand-charcoal/60" data-id="element-230">
                          {t.age}
                        </p>
                      </div>
                      <div className="bg-brand-cream px-3 py-1.5 rounded-full border border-brand-green/20" data-id="element-231">
                        <p className="text-xs font-bold text-brand-green uppercase tracking-wider" data-id="element-232">
                          Resultado: {t.result}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-6" data-id="element-233">
            {testimonials.map((_, index) => <button key={index} onClick={() => goTo(index)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === current ? 'bg-brand-green w-6' : 'bg-brand-green/25 hover:bg-brand-green/50'}`} aria-label={`Ir al testimonio ${index + 1}`} data-id="element-234" />)}
          </div>
        </div>

        <SectionDivider data-id="element-235" />
      </div>
    </section>;
}